import { createApp } from "vue";
import Antd from "ant-design-vue";
import Iconfont from "./components/icon-font";
import "ant-design-vue/dist/antd.less";
import "animate.css";
import "./style/var.scss";
import "./style/base.less";
import "./style/layout.less";
import "./style/App.less";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./lang";
import { useLatex } from "./directive/latexRender";

const app = createApp(App);
useLatex(app);
app
  .use(i18n)
  .use(Antd)
  .use(store)
  .use(router)
  .component("IconFont", Iconfont)
  .mount("#root");
